module.exports = __webpack_public_path__ + "img/magic-comment-purple.6513ca73.svg";